<template>
  <div id="HolterDepositMachineList">
      <div id="container-center">
        <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 院内貸出機患者利用申込一覧</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>受付番号</th>
              <td colspan="3"><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber" style="width: 100%;"/></td>
              <th>機種</th>
              <td colspan="3"><select id="instrumentKind" v-model="searchConditions.model"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
            </tr>
            <tr>
              <th>申込日</th>
              <td colspan="3"><input type="date" id="applicationDateStart" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" id="applicationDateEnd" v-model="searchConditions.applicationDateEnd"/></td>
              <th>出荷日</th>
              <td colspan="3"><input type="date" id="shippingDateStart" v-model="searchConditions.shippingDateStart"/> ～ <input type="date" id="shippingDateEnd" v-model="searchConditions.shippingDateEnd"/></td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="goHome">戻る</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="hasResult">
          <b-table
              id="HolterDepositMachineListTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page">
              <template slot-scope="props">
                <b-table-column field="receiptNumber" label="受付番号" width="150" centered>
                  <router-link :to="{name:'HolterDepositMachineRequestFormOrder', params: linkParams(props)}"><a>{{props.row.receiptNumber}}</a></router-link>
                  <span v-if="props.row.depositMachineFlag" class="depo"/><span style="position:relative; top:17px;" v-if="props.row.maintenanceNotice" class="maintenance"/>
                </b-table-column>
                <b-table-column field="receiptNumber" label="シリアルNo" width="150" centered>
                  {{props.row.serial }}
                </b-table-column>
                <b-table-column field="instrumentKind" label="機種" width="100" >
                  {{props.row.instrumentKind}}
                  <!-- ePatch -->        
                </b-table-column>
                <b-table-column field="inspectionPeriod" label="検査期間" width="200" centered>
                  {{props.row.inspectionPeriod | getNameFilter(inspectionPeriodList)}}
                </b-table-column>
                <b-table-column field="applicationDate" label="申込日" width="150" centered>
                  {{props.row.applicationDate }}
                </b-table-column>
                <b-table-column field="shippingDate" label="出荷日" width="100" centered>
                  {{props.row.shippingDate }}
                </b-table-column>
              </template>
          </b-table>
        </div>
      </div>
  </div>
</template>
<script>
import naviBar from "@/components/mock/philips/holter/HolterNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
export default {
  name: "HolterDepositMachineList",
  methods: {
    goHome: function() {
      this.$router.push({ path: "/guest/holterMenu" });
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHolterDepositMachineRequestListPOST;
      var successCallBack = this.getHolterDepositMachineRequestListPOSTSuccess;
      var errorCallBack = this.getHolterDepositMachineRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterDepositMachineRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.externalHolter.getHolterDepositMachineRequestListPOST({
        body:obj
      });
    },
    getHolterDepositMachineRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true;
    },
    getHolterDepositMachineRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.modelList = this.getChoiceList(this.choicesType.holterKind, false);
      this.modelList.unshift({})
    },
    linkParams(props) {
      let params = {
        receiptNumber: props.row.receiptNumber,
        serial: props.row.serial,
        depositMachineFlag: props.row.depositMachineFlag,
        searchConditions: this.searchConditions,
        inspectionPeriod: props.row.inspectionPeriod,
        maintenanceNotice: props.row.maintenanceNotice,
        preReceiptNumber: this.preReceiptNumber ? this.preReceiptNumber : null,
        inspectionPeriodList: this.inspectionPeriodList
      };
      if (this.preKind) {
        params.preKind = this.preKind;
      }
      return params;
    },
    getOwnOrganizationList: function() {
      // Web Api Call
      
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getHolterJudgmentFlagPOST({
            body:{
              orgId: _this.userInfo.belongsId,
            }
          });
        },
        function(result) {
          if(result.obj.holterJudgmentFlg){
            _this.holterJudgmentFlg = true
            _this.inspectionPeriodList = _this.getChoiceList(choicesType.holterInspectionPeriodJudgment, true); 
          }else{
            _this.holterJudgmentFlg = false
            _this.inspectionPeriodList = _this.getChoiceList(choicesType.holterInspectionPeriod, true); 
          }
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    }
  },
  data() {
    let takeOverSearchParams = this.$route.params["searchConditions"];
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    // 継続申請/転院紹介
    const preReceiptNumber = this.$route.params['receiptNumber']
    const preKind = this.$route.params['kind']

    return {
      searchConditions:{
        receiptNumber:"",
        model:"",
        patientName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        shippingDateStart:"",
        shippingDateEnd:""
      },
      userInfo: userInfo,
      choicesType:choicesType,
      data : [],
      isPaginated : true,
      hasResult:false,
      takeOverSearchParams,
      modelList:[],
      inspectionPeriodList : null,
      preReceiptNumber,
      preKind,
      holterJudgmentFlg: false,
    };
  },
  async mounted() {

    this.getOwnOrganizationList()
    // 選択肢マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
  },
  components: {
    holterNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/guest/HolterDepositMachineList.vue